import { Controller } from "@hotwired/stimulus"
import Quill from "quill";
import { SizeStyle } from "quill/formats/size";
import "quill/dist/quill.snow.css"

SizeStyle.whitelist = ['14px', '16px', '18px', '24px', '28px', '36px', '48px'];
Quill.register(SizeStyle, true);

export default class extends Controller {
  static targets = [ "container", "input" ];

  connect() {
    this.initField();
  }


  
  toggleEditMode(event) {
    event.preventDefault();

    if (this.containerTarget.style.display !== 'none') {
      // Переключаем на textarea
      this.destroyEditor();
      this.containerTarget.style.display = 'none';
      this.inputTarget.style.display = 'block';
      this.inputTarget.value = this.quillInstance ? this.quillInstance.root.innerHTML : this.inputTarget.value;
    } else {
      // Переключаем обратно на Quill editor
      this.inputTarget.style.display = 'none';
      this.containerTarget.style.display = 'block';
      this.initEditor();
    }
  }

  initField() {
    if (this.containerTarget.style.display !== 'none') {
      this.initEditor();
    }
  }

  initEditor() {
    const toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
      [{ 'size': ['14px', '16px', '18px', '24px', '28px', '36px', '48px'] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'align': [] }],
      ['clean']                                         // remove formatting button
    ];

    // Убедимся, что Quill не инициализирован дважды
    if (!this.quillInstance) {
      this.quillInstance = new Quill(this.containerTarget, {
        modules: { toolbar: toolbarOptions },
        theme: 'snow'
      });
      this.quillInstance.on('text-change', this.updateTextarea.bind(this));
    }
    
    // Установим содержимое редактора, если значение доступно
    if (this.inputTarget.value) {
      this.quillInstance.root.innerHTML = this.inputTarget.value;
    }
  }

  destroyEditor() {
    if (this.quillInstance) {
      this.quillInstance.off('text-change', this.updateTextarea.bind(this));
      // Полное удаление Quill редактора
      this.quillInstance.root.innerHTML = '';
      let quillToolbar = this.containerTarget.previousElementSibling;
      if (quillToolbar && quillToolbar.classList.contains('ql-toolbar')) {
        quillToolbar.remove();
      }
      this.quillInstance = null;
    }
  }

  updateTextarea() {
    if (this.quillInstance) {
      this.inputTarget.value = this.quillInstance.root.innerHTML;
    }
  }
}
